import React, { Fragment, useState } from "react";

// Antd
import { Modal } from "antd";

function ThankYouModal({ onShowModal, onHandleCloseModal }) {
  return (
    <Modal
      // title="MIIP Gala Dinner & Awards Night 2024 Confirmation"
      centered
      open={onShowModal}
      onOk={onHandleCloseModal}
      onCancel={onHandleCloseModal}
      // closeIcon={}
      // closable={true}
      maskClosable={false}
      footer={[]}
    >
      <div className="modalBody">
        <p className="m-t-20">
          Thank you for registering. Please present this QR code on the day of
          the event for check-in purposes.
        </p>
      </div>
    </Modal>
  );
}

export default ThankYouModal;
